/** The public Learn hub: /academy, /academy/articles, /academy/{category,topic,course,article}/:id. */
import { usePath } from '../../../lib/router';
import { ArticlePage } from './ArticlePage';
import { LearnShell } from './chrome';
import { usePageHead } from './head';
import { Home } from './Home';
import { ArticlesPage, CategoryPage, CoursePage, TopicPage } from './Listings';
import { parseLearnRoute, type LearnRoute } from './routes';

function Listing({ route }: { route: Exclude<LearnRoute, { kind: 'article' }> }) {
  usePageHead(route);
  switch (route.kind) {
    case 'home':
      return <Home />;
    case 'articles':
      return <ArticlesPage />;
    case 'category':
      return <CategoryPage id={route.id} />;
    case 'topic':
      return <TopicPage id={route.id} />;
    case 'course':
      return <CoursePage id={route.id} />;
  }
}

export default function LearnPage() {
  const route = parseLearnRoute(usePath()) ?? { kind: 'home' };
  return <LearnShell>{route.kind === 'article' ? <ArticlePage key={route.slug} slug={route.slug} /> : <Listing route={route} />}</LearnShell>;
}
